module.exports = __webpack_public_path__ + "img/products_big_can_lychee.21654ae1.png";